import { render } from "./CssDimensionEditor.vue?vue&type=template&id=2bfbe690&scoped=true&ts=true"
import script from "./CssDimensionEditor.vue?vue&type=script&lang=ts"
export * from "./CssDimensionEditor.vue?vue&type=script&lang=ts"

import "./CssDimensionEditor.vue?vue&type=style&index=0&id=2bfbe690&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfbe690"]])

export default __exports__